import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=39ae58f0&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"
import style0 from "./index2.vue?vue&type=style&index=0&id=39ae58f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae58f0",
  null
  
)

export default component.exports